import styled from 'styled-components'

export const SelectWrap = styled.div`
  width: 100%;
`
